import React from 'react';

import ClaimStepContainer from '../common/ClaimStepContainer';

function WholeDamageStepContainer(props) {
  return <ClaimStepContainer {...props} subHeading="WHOLE_DAMAGE_CLAIM_FLOW_HEADING" confirmExit />;
}

export default React.memo(WholeDamageStepContainer);
